import { theme, ThemeConfig } from "antd";
import novaTheme from "./novaTheme";

const antdTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,

  token: {
    // Colores principales
    colorPrimary: novaTheme.colors.blue400,
    colorInfo: novaTheme.colors.blue300,
    colorSuccess: novaTheme.colors.green300,
    colorWarning: novaTheme.colors.red50,
    colorError: novaTheme.colors.red50,
    colorTextBase: novaTheme.colors.blueGray900,
    colorText: novaTheme.colors.blueGray800,
    colorTextSecondary: novaTheme.colors.blueGray400,
    colorBorder: novaTheme.colors.blueGray200,
    colorBgBase: novaTheme.colors.white50,
    colorBgContainer: novaTheme.colors.white50,
    colorBgElevated: novaTheme.colors.white50,
    colorFillSecondary: novaTheme.colors.white50,

    // Tipografía
    fontFamily: novaTheme.fonts.ProximaNova,
    fontSize: 16,

    // Bordes y radios
    borderRadius: 8,

    // Botones
    controlHeight: 40,
    controlPaddingHorizontal: 12
  },

  components: {
    Button: {
      colorPrimary: novaTheme.colors.blue400,
      colorPrimaryHover: novaTheme.colors.blue300Light,
      colorPrimaryActive: novaTheme.colors.blue300Lighter,
      borderRadius: 6
    },
    Input: {
      colorBgBase: novaTheme.colors.white50,
      colorText: novaTheme.colors.blueGray900,
      borderRadius: 6
    },
    Card: {
      colorBgContainer: novaTheme.colors.white50,
      borderRadius: 12
    },
    Modal: {
      borderRadius: 12,
      colorBgBase: novaTheme.colors.white50
    }
  }
};

export default antdTheme;
